<template>
  <div 
    :menuSequencingDataObserver="menuSequencingData"
    :id="'category_items_id_' + getSingleProductItemCategory?.categoryId"
    class="horizontall-scroll-anim"
    :selectedMenuCategoryForceProp="checkSepMenuPage ? getSelectedMenuCategory : ''"
  >
    <p :id="'element_catg_' + getSingleProductItemCategory?.categoryId"></p>
    <div
      v-if="
        moduleProps &&
        isCorrectModuleType &&
        Object.keys(getSingleProductItemCategory?.data || {})?.length > 0
      "
      class="cards-wrap mb30 clearfix options-api"
      :style="{ minHeight: minHeightCal + 'px' }"
    >
      <Observer 
        :options="getObserverOptions"
        @intersect="itisvisible" 
      />
      <div v-if="!isEdvPage" class="flex-row" :class="{ mb16: showSmallCards }">
        <span class="center-flexible-line"></span>
        <span
          ><h3
            class="card-catg-name"
            :class="[isAnchorLinkVariant ? 'color-slaty' : '']"
          >
            {{ getSingleProductItemCategory?.categoryName }}
          </h3></span
        >
        <span class="center-flexible-line"></span>
      </div>

      <Observer
        :options="{ rootMargin: '-50px' }"
        @intersect="itisvisibleTop"
      />
      <div class="cards-holder" v-if="showList">
        <product-card
          v-for="(value, key, index) in getSingleProductItemCategory?.data"
          :key="key"
          :data-cardRounded="vpsProps.cardRounded"
          :data-cardSearchable="vpsProps.cardSearchable"
          :data-showUpsell="vpsProps.showUpsell"
          :data-showCrossell="vpsProps.showCrossell"
          :data-result="value"
          :data-index="index"
          :data-moduleProps="moduleProps"
          :data-counterText="
            'Showing ' +
            categoryName +
            ' | ' +
            (index + 1) +
            '/' +
            Object.keys(getSingleProductItemCategory?.data)?.length
          "
          :data-categoryId="getSingleProductItemCategory?.categoryId || '-1'"
          :data-type="getSingleProductItemCategory?.categoryName"
          data-card-source="VPS"
        ></product-card>
      </div>
    </div>
    <Observer 
      :options="getObserverOptions"
      @intersect="itisvisible" 
      :style="{ bottom: 0 }" 
    />
  </div>
</template>

<script>
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import ProductCard from "./ProductCard.vue";
import Observer from "../assets/Observer.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import horizontalSwipe from "../helpers/horizontalSwipe";
import PageNames from "../config/pageNames";

export default {
  name: "VerticalProductScroll",
  props: ["dataResults", "moduleProps", "productCategory"],
  components: {
    ProductCard,
    Observer,
  },
  data() {
    return {
      isCorrectModuleType: false,
      vpsProps: {
        cardRounded: false,
        cardSearchable: false,
        showUpsell: true,
        showCrossell: true,
      },
      categoryName: "",
      defaultModuleProperties: {
        cardType: "video/static",
        itemsInScreen: "1.75",
        aspectRatio: "1",
        title: "Best Sellers",
        type: "VERTICAL_PRODUCT_SCROLL",
      },
      showList: false,
      isUpdated: false,
      parsedResults: [],
      convertData: [],
      isMenuSequenceProcessed: false,
      isEdvPage: false,
      OldData: null,
      dataafterconverion: null,
    };
  },
  mounted() {
    this.isEdvPage = Utility.isEdvPage();

    if (this.isEdvPage) {
      this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    } else {
      let moduleArray = [];
      try {
        moduleArray = JSON.parse(this.dataResults);
      } catch (e) {
        console.log("Invalid JSON in dataResults", e);
      }

      this.dataafterconverion = Utility.convertValidItemsToFinalData(moduleArray);

      const moduleObj = moduleArray?.[0];
      const categoryIdFromModule = moduleObj?.metadataMap?.categoryId?.values?.[0];

      const allCategories = this.$store.state.ProductItems.productItems;
      let matchedCategory = null;

      Object.values(allCategories).forEach((cat) => {
        if (String(cat.categoryId) === String(categoryIdFromModule)) {
          matchedCategory = {
            ...cat,
            data: Object.values(cat.data || {}),
          };
        }
      });

      this.OldData = matchedCategory ? [matchedCategory] : [];
      this.parsedResults = this.OldData;
    }

    this.defaultModuleProperties = Utility.tryJsonParse(
      this.moduleProps,
      this.defaultModuleProperties
    );

    if (
      this.defaultModuleProperties.productCategory &&
      this.defaultModuleProperties.productCategory === "edv" &&
      this.parsedResults &&
      this.parsedResults.length > 0 &&
      this.defaultModuleProperties
    ) {
      this.parsedResults[0].categoryName =
        this.defaultModuleProperties.categoryName;
      this.parsedResults[0].categoryId =
        this.defaultModuleProperties.deal_id;
    }

    this.checkModuleTypeToRender();

    this.categoryName = this.parsedResults?.[0]?.categoryName;

    if (this.categoryName) {
      this.$store.commit(keyMapsMutation.ADD_CATEGORY_SEQUENCE, this.categoryName);
    }

    if (this.isEdvPage) {
      this.processResultDataForStore(this.parsedResults);
    }

    const currentCategoryId = this.parsedResults?.[0]?.categoryId || this.getSingleProductItemCategory?.categoryId;
    
    if (currentCategoryId) {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_CATEGORY_STATUS, {
        categoryId: currentCategoryId,
        showCategory: true
      });
    }

    const {
      titleTagImageUrl = "",
      titleTagImageWidth = "",
      titleTagImageUrlHeight = "",
      verticalMenuListingTagImageUrl = "",
      verticalMenuListingTagImageWidth = "",
      verticalMenuListingTagImageHeight = "",
    } = this.defaultModuleProperties;

    if (titleTagImageUrl || verticalMenuListingTagImageUrl) {
      this.$store.commit(keyMapsMutation.UPDATE_TAG_IMAGE_INFO_OBJ, {
        [this.categoryName]: {
          titleTagImageUrl: titleTagImageUrl,
          titleTagImageWidth: titleTagImageWidth,
          titleTagImageUrlHeight: titleTagImageUrlHeight,
          verticalMenuListingTagImageUrl: verticalMenuListingTagImageUrl,
          verticalMenuListingTagImageWidth: verticalMenuListingTagImageWidth,
          verticalMenuListingTagImageHeight: verticalMenuListingTagImageHeight,
        },
      });
    }
  },
  methods: {
    checkSepMenuPage() {
      let linkRewrite = Utility.getCurrentStoreFolder(); // /menu/
      linkRewrite = "pwa" + linkRewrite;
      if (linkRewrite === "pwa/menu/") {
        return true;
      }
      return false;
    },
    checkModuleTypeToRender() {
      if (this.defaultModuleProperties?.type === "VERTICAL_PRODUCT_SCROLL") {
        this.isCorrectModuleType = true;
      }
    },
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCT_ITEMS, data);
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_FROM_LOCAL_STORAGE,
        this.$store.state.ProductItems.unfilteredProductItems
      );
      this.$store.commit(
        keyMapsMutation.LOAD_UNIQUE_CART_ITEMS,
        this.$store.state.Cart.cartItems
      );

      let _ = LocalStorageFunc.getSessionStorageKey("orderFiltersData");
      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [
          ...(_.appliedFilters || []),
          ...(_.appliedSortFilters || []),
        ],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters[keyMapsGetter.CART_QUANTITY],
      });
    },
    itisvisibleTop() {
      if (!this.isUpdated) {
        //Amplitude impression event load
        let sectionName = this.getSingleProductItemCategory?.categoryName;
        if (sectionName) {
          sectionName = sectionName.toLowerCase() + " cards";
        }
        const preEventObj = {
          screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
          positionWithinSection: 1,
          category:
            this.getSingleProductItemCategory?.categoryName?.toLowerCase(),
        };
        const eventObj = Utility.amplitudeEventObj(
          "impression",
          sectionName,
          "14",
          preEventObj
        );
        setEvents("amplitude", "Impression", eventObj);
        this.isUpdated = true;
      }
    },
    itisvisible() {
      this.showList = true;
    },
    isMenuSequencingEnabled() {
      return window?._siteProps_?.props?.enableMenuSequencing === "true";
    },
    toggle(className, displayState){
      var elements = document.getElementsByClassName(className)
      for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
      }
    },

  },
  computed: {
    getSingleProductItemCategory() {
      let isEdvPage = Utility.isEdvPage();

      if (!isEdvPage) {
        let categoryData = JSON.parse(this.dataResults);
        const categoryObj = {
          categoryId: categoryData?.[0]?.metadataMap?.categoryId?.values?.[0],
          categoryName: categoryData?.[0]?.nodeName,
          data: {}
        };
        const categoryInfo = this.$store.state.ProductItems.productItems?.[categoryObj.categoryName];

        return categoryInfo || categoryObj;
      }
      else {
        return this.$store.getters[
          keyMapsGetter.GET_SINGLE_PRODUCT_ITEM_CATEGORY
        ](this.categoryName);
      }
    },
    openAllCards() {
      return this.$store.state.ProductItems.openAllCards;
    },
    showSmallCards() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_b" ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_u"
      ) {
        return true;
      } else {
        return false;
      }
    },
    minHeightCal() {
      if (window.screen.width >= 740) {
        return;
      }
      let count = Object.keys(
        this.getSingleProductItemCategory?.data || {}
      )?.length;
      // console.log('count all...', this.getSingleProductItemCategory?.categoryName, count, 366*count+37);
      if (!this.showSmallCards) {
        return 366 * count + 37;
      } else {
        return 196 * count + 37;
      }
    },
    menuSequencingData() {
      const menuSeqData = this.$store.state.ProductItems.menuSequencingData;
      const categoryId = this.parsedResults?.[0]?.categoryId;

      if (
        menuSeqData[categoryId] &&
        !this.isMenuSequenceProcessed &&
        this.isMenuSequencingEnabled()
      ) {
        this.isMenuSequenceProcessed = true;

        if (this.isEdvPage) {
          this.processResultDataForStore(
            Utility.sequencedProductItems(
              this.parsedResults,
              menuSeqData[categoryId]
            )
          );
        }
      }
    },

    isAnchorLinkVariant() {
      if (Utility.isSeparateMenuVariant()) {
        this.addHorizontalSwipe;
        return true;
      } else {
        return false;
      }
    },
    addHorizontalSwipe() {
      setTimeout(() => {
        if(this.getSingleProductItemCategory?.categoryId) {
          let ele = document.getElementById("category_items_id_" + this.getSingleProductItemCategory?.categoryId);
          ele.addEventListener('touchstart', horizontalSwipe.handleTouchStart, true);
          ele.addEventListener('touchmove', horizontalSwipe.handleTouchMove, true);
        }
      }, 200);
    },
    getObserverOptions() {
      if (Utility.isSeparateMenuVariant()) {
        return { root: null,threshold: 0,rootMargin: '0%' };
      }
      else {
        return {rootMargin: '750px'};
      }
    },
    getSelectedMenuCategory() {
      const selectedCategory =
        this.$store.getters[keyMapsGetter.GET_SELECTED_MENU_CATEGORY]; 
      if (
        selectedCategory.category ===
          this.getSingleProductItemCategory?.categoryName &&
        !this.showList
      ) {
        this.showList = true;
      }
    },
  },
};
</script>
